import Vue from 'vue';
import ServiceBundleSegments from '@/plugins/graphql/queries/v2/service-bundle-segments-basic.gql';
import { CustomerSegmentModel } from '@/helpers/entities/models/CustomerSegmentModel';
import { omitBy, isNull } from 'lodash';
export default Vue.extend({
    apollo: {
        serviceBundleSegments: {
            query: ServiceBundleSegments,
            variables() {
                const vars = {
                    appUuid: this.appUuid,
                    category: this.category,
                };
                return omitBy(vars, isNull);
            },
            update(data) {
                const segmentNode = (segment) => {
                    return new CustomerSegmentModel(segment.node);
                };
                return data.serviceBundleSegments.edges.map(segmentNode);
            },
        },
    },
    props: {
        appUuid: {
            type: String,
            required: true,
        },
        category: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            serviceBundleSegments: null,
        };
    },
    computed: {
        serviceBundleSegmentsData() {
            const self = this;
            if (self.serviceBundleSegments) {
                return self.serviceBundleSegments.map((serviceBundleSegment) => {
                    return {
                        ...serviceBundleSegment,
                        segmentValue: serviceBundleSegment.humanizedName,
                    };
                });
            }
            return [];
        },
    },
    render() {
        if (this.$scopedSlots.default) {
            const self = this;
            return this.$scopedSlots.default({
                segments: self.serviceBundleSegmentsData,
            });
        }
    },
});
